import { createApp } from "vue"
import * as Sentry from "@sentry/vue"
import router from "./router"
import { i18n } from "./i18n"
import uiPlugin from "@nuxt/ui/vue-plugin"
import store, { useLocale, useUser, useConfig } from "@/store"
import { bootApp } from './boot';
import meta from "@/Meta"

import "./assets/main.css"
import App from "./App.vue"

const vue = createApp(App);
vue.use(store);

bootApp().then(_ => {
  const config = useConfig().configuration;
  
  if (config.sentry?.dsn) {
    Sentry.init({
      app: vue,
      dsn: config.sentry.dsn,
      environment: config.sentry.environment,
      release: `eorders-web@${meta.version}`,
      integrations: [
        Sentry.browserTracingIntegration({ router }),
      ],
      tracesSampleRate: config.sentry.tracesSampleRate ?? 0.1,
      tracePropagationTargets: [config.baseApiUrl],
    });
  }
  
  useUser()
    .silentLogin()
    .then(authenticated => {
      //if (authenticated) {
      
        useLocale().initializeLocale();
        
        vue.use(uiPlugin);
        vue.use(router);
        vue.use(i18n);

        vue.mount('#app');
      //}
    });
});
